import * as Types from '../../../declarations'
import { Button } from '@mantine/core'
import { IconCameraPlus } from '@tabler/icons-react'
import * as AppStore from './../../../state/app-store'
import * as Actions from './../../../state/actions'
// import { useIsMobile } from '../../../lib/useIsMobile'

const PictureUploadButton = () => {
	// const isMobile = useIsMobile()

	const dispatch = AppStore.useAppDispatch()

	const openAddPictures = () =>
		dispatch(
			Actions.openSuggestFeedbackModal(
				Types.App.DataTypes.FeedbackSection.PICTURES,
			),
		)

	return (
		<>
			<Button
				leftSection={<IconCameraPlus size={16} />}
				variant="outline"
				radius="sm"
				size="compact-sm"
				onClick={openAddPictures}
			>
				Add your pictures
			</Button>
		</>
	)
}

export default PictureUploadButton
